import React from 'react';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { AdPlaceholder } from './AdPlaceholder';
import { SubNavigation } from './SubNavigation';
import { Link } from 'react-router-dom';
export function MarketIQLayout({
  children,
  activeSection
}: {
  children: React.ReactNode;
  activeSection?: 'beef' | 'pork' | 'chicken' | null;
}) {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-173" data-mp="y7u80ug9qvnz">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-174" data-mp="y9nfud2mblxk">
        <Header data-id="element-175" data-mp="tfjafy903lyl" />
        <Navigation data-id="element-176" data-mp="tf13a6ksvnbw" />
      </div>

      <SubNavigation activeSection={activeSection} data-id="element-177" data-mp="ohhp16o3rajy" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-178" data-mp="oiamti532ppy">
        {/* Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-179" data-mp="jkr70dsqm4vw">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Advertisement" data-id="element-180" data-mp="ek3875y9ojr4" />
        </div>

        {/* Breadcrumb */}
        <nav className="text-sm text-gray-600 mb-8" data-id="element-181" data-mp="u2y6h6tfy0s8">
          <Link to="/" className="text-[#002f5f] hover:underline" data-id="element-182" data-mp="u1ddhlmrypwh">
            Home
          </Link>
          <span className="mx-1" data-id="element-183" data-mp="yupo2rumcw68">»</span>
          {activeSection ? <>
              <Link to="/market-iq" className="text-[#002f5f] hover:underline" data-id="element-184" data-mp="k63aaukn4ch4">
                Market IQ
              </Link>
              <span className="mx-1" data-id="element-185" data-mp="p18v1q2b3l3m">»</span>
              <span className="text-gray-900 capitalize" data-id="element-186" data-mp="1cswg3rcw01xz">{activeSection}</span>
            </> : <span className="text-gray-900" data-id="element-187" data-mp="1hr7py236mcg7">Market IQ</span>}
        </nav>
      </div>

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-188" data-mp="13rg4xhe8zvsp">
        {children}
      </div>

      {/* Footer */}
      <footer className="mt-auto bg-gray-100 border-t border-gray-200" data-id="element-189" data-mp="17s9sg9ns38l2">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-190" data-mp="3ohnkb38nchz4">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-6" data-id="element-191" data-mp="3sktrcd3l2d6n">
            <div className="text-2xl font-bold tracking-tight text-gray-400" data-id="element-192" data-mp="1z1uujqwlwosl">
              SOSLAND PUBLISHING
            </div>
            <div className="flex items-center gap-3" data-id="element-193" data-mp="1u30aymqtew7f">
              <a href="#" className="w-9 h-9 rounded bg-gray-700 flex items-center justify-center text-white text-sm hover:bg-gray-600" data-id="element-194" data-mp="1pb9wq5orboaq">
                f
              </a>
              <a href="#" className="w-9 h-9 rounded bg-gray-700 flex items-center justify-center text-white text-sm hover:bg-gray-600" data-id="element-195" data-mp="1gc4yl0h3xwz3">
                in
              </a>
              <a href="#" className="w-9 h-9 rounded bg-gray-700 flex items-center justify-center text-white text-sm hover:bg-gray-600" data-id="element-196" data-mp="16dfqfzf0jqw1">
                rss
              </a>
            </div>
          </div>

          <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#002f5f] mb-4" data-id="element-197" data-mp="2vrc78pu0bb3s">
            <a href="#" className="hover:underline" data-id="element-198" data-mp="348uqqq6mv0yf">
              Sosland Publishing
            </a>
            <a href="#" className="hover:underline" data-id="element-199" data-mp="38a7tgrefio14">
              Editorial Staff
            </a>
            <a href="#" className="hover:underline" data-id="element-200" data-mp="3d1g4tszbkjgx">
              Subscriptions
            </a>
            <a href="#" className="hover:underline" data-id="element-201" data-mp="3hzzrjvlqlzac">
              Media Guide
            </a>
            <a href="#" className="hover:underline" data-id="element-202" data-mp="2la0a1bnlzqfm">
              Contact Us
            </a>
          </div>

          <p className="text-xs text-gray-500 mb-3" data-id="element-203" data-mp="2pbbyveyns7mr">
            ©2026 SOSLAND PUBLISHING COMPANY
          </p>

          <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-gray-500" data-id="element-204" data-mp="2uaf7189xqtyy">
            <a href="#" className="hover:underline" data-id="element-205" data-mp="2z9i3437xtpus">
              Privacy Policy
            </a>
            <span data-id="element-206" data-mp="9kpskwd59a6s">|</span>
            <a href="#" className="hover:underline" data-id="element-207" data-mp="9jedw1i5ui0w">
              Terms of Use
            </a>
            <span data-id="element-208" data-mp="eirbnhakl9i9">|</span>
            <a href="#" className="hover:underline" data-id="element-209" data-mp="ehzgu8osrft1">
              Terms & Conditions for Advertisers
            </a>
            <span data-id="element-210" data-mp="1nilg1r9hfdh2">|</span>
            <a href="#" className="hover:underline" data-id="element-211" data-mp="1ihnz1i07kph5">
              California Privacy Policy
            </a>
            <span data-id="element-212" data-mp="1whoziwck9uw3">|</span>
            <a href="#" className="hover:underline" data-id="element-213" data-mp="1wi8fw8mkcb80">
              Do not sell my information
            </a>
            <span data-id="element-214" data-mp="1rhayvzdahn83">|</span>
            <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="hover:underline text-[#002f5f] font-medium" data-id="element-215" data-mp="1rk72a37wp43x">
              Data Source & Methodology
            </a>
          </div>

          <p className="text-xs text-gray-400 mt-3" data-id="element-216" data-mp="2b61xtzz4fptr">
            Design, CMS, Hosting & Web Development :: ePublishing
          </p>
        </div>
      </footer>
    </div>;
}